export default __webpack_public_path__ + "static/media/163.7810c165.png";